import { NgModule } from '@angular/core';
import { LoginComponent } from './pages/auth/login/login.component';
import { authGuard } from './auth.guard';
import { CreateAccountComponent } from './pages/auth/create-account/create-account.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { RouterModule, Routes, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
export const rootRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role'); // 👈 make sure you save role at login time

  console.log('is logged in:', !!token, 'role:', role);

  if (token) {
    // 🔹 Role based redirects
    switch (role) {
      case 'student':
        router.navigate(['/student/chat']);
        break;
      case 'teacher':
        router.navigate(['/teacher/dashboard']);
        break;
      case 'school_admin':
        router.navigate(['/admin/dashboard']);
        break;
      case 'super_admin':
        router.navigate(['/superadmin/dashboard']);
        break;
      default:
        router.navigate(['/student/chat']); // fallback if no role
    }
    return false; // prevent accessing login/root
  }

  return true; // allow login/root if not logged in
};
// Role-based guard factory
export function roleGuard(allowedRoles: string[]): CanActivateFn {
  return () => {
    const router = inject(Router);
    const role = localStorage.getItem('role');
    if (!!role && allowedRoles.includes(role)) return true;
    router.navigate(['/login']);
    return false;
  };
}
const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [rootRedirectGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'create-account', component: CreateAccountComponent },

  {
    path: 'student',
    canActivate: [authGuard, roleGuard(['student'])],
    loadChildren: () => import('./student/student.module').then(m => m.StudentModule),
  },

  {
    path: 'admin',
    canActivate: [authGuard, roleGuard(['school_admin'])], // ✅ only school_admin
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'superadmin',
    canActivate: [authGuard, roleGuard(['super_admin'])], // ✅ only superadmin
    loadChildren: () => import('./superadmin/superadmin.module').then(m => m.SuperadminModule),
  },
  {
    path: 'teacher',
    canActivate: [authGuard, roleGuard(['teacher'])], // ✅ only teachers
    loadChildren: () => import('./teachers/teachers.module').then(m => m.TeachersModule),
  },

  { path: 'privacy-policy', component: PrivacyPolicyComponent },

  { path: '**', redirectTo: 'login' },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
